module.exports = __webpack_public_path__ + "static/media/nordland_luke-stackpoole-By9u0AV2fm4-unsplash.d4ee2075.jpg";